"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Masthead = void 0;
var react_1 = __importDefault(require("react"));
function Masthead() {
    return (react_1.default.createElement("header", { className: "masthead masthead-shop text-white text-center" },
        react_1.default.createElement("div", { className: "overlay" }),
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-xl-9 mx-auto" },
                    react_1.default.createElement("h1", { className: "text-white" },
                        "EXAMENTRAINING VAN ",
                        react_1.default.createElement("br", null),
                        "READY TO SCHOOL"))))));
}
exports.Masthead = Masthead;
